export default __webpack_public_path__ + "static/media/topping_wine.6029893c.jpg";